import { StyledComponentProps } from '@material-ui/core';
import { DatePicker, DateTimePicker, DateTimePickerProps } from '@material-ui/pickers';
import * as React from 'react';

export type IDeliveryDayStatus = 'AVAILABLE' | 'UNKNOWN' | 'UNAVAILABLE';

interface OcDatetimePickerProps extends DateTimePickerProps, StyledComponentProps {
	type: 'NOTHING' | 'DATE' | 'DATETIME'
	dayStatusMap: Map<string, IDeliveryDayStatus>
}

function OcDatetimePicker(props: OcDatetimePickerProps) {
	const { value, onChange, label, error, required, type, inputVariant, dayStatusMap } = props;
	const classes = props.classes || {};

	switch (type) {
	case 'DATETIME': return <DateTimePicker
		inputVariant={inputVariant}
		value={value}
		onChange={onChange}
		format="DD.MM.YYYY HH:mm"
		ampm={false}
		label={label}
		required={required}
		error={error}
		className={classes.choiceBox}
	/>;
	case 'DATE': return <DatePicker
		inputVariant={inputVariant}
		value={value}
		onChange={onChange}
		format="DD.MM.YYYY"
		label={label}
		required={required}
		error={error}
		className={classes.choiceBox}
	/>;
	}
	return null;
}

export default OcDatetimePicker;
